import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ShieldAlert, CheckSquare, Activity, Database, Settings, Users, AlertTriangle, ServerCrash } from 'lucide-react';
export function AdminDashboardPage() {
  return <div className="min-h-screen bg-background text-textMain flex flex-col" data-id="element-900">
      <header className="h-16 border-b border-border flex items-center justify-between px-6 bg-surface shrink-0" data-id="element-901">
        <div className="flex items-center gap-4" data-id="element-902">
          <span className="text-xl font-bold text-red-500" data-id="element-903">Booker Admin</span>
          <div className="w-px h-6 bg-border" data-id="element-904"></div>
          <nav className="flex items-center gap-4 text-sm font-medium" data-id="element-905">
            <Link to="/admin" className="text-textMain" data-id="element-906">
              Dashboard
            </Link>
            <Link to="/admin/approvals" className="text-textMuted hover:text-textMain" data-id="element-907">
              Approvals
            </Link>
            <Link to="/admin/audit-log" className="text-textMuted hover:text-textMain" data-id="element-908">
              Audit Log
            </Link>
          </nav>
        </div>
        <div className="flex items-center gap-3" data-id="element-909">
          <div className="w-8 h-8 rounded-full bg-red-500/20 text-red-500 flex items-center justify-center text-xs font-bold" data-id="element-910">
            AD
          </div>
        </div>
      </header>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="flex-1 p-8 max-w-7xl mx-auto w-full" data-id="element-911">
        <div className="mb-8" data-id="element-912">
          <h1 className="text-2xl font-bold mb-1" data-id="element-913">System Overview</h1>
          <p className="text-sm text-textMuted" data-id="element-914">
            Operational visibility and review queues.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-id="element-915">
          <div className="bg-surface border border-border rounded-xl p-5" data-id="element-916">
            <div className="flex items-center justify-between mb-2" data-id="element-917">
              <div className="w-10 h-10 rounded-lg bg-amber-500/10 flex items-center justify-center text-amber-500" data-id="element-918">
                <CheckSquare className="w-5 h-5" data-id="element-919" />
              </div>
            </div>
            <p className="text-sm text-textMuted mb-1" data-id="element-920">Pending Approvals</p>
            <h4 className="text-2xl font-bold" data-id="element-921">14</h4>
          </div>
          <div className="bg-surface border border-border rounded-xl p-5" data-id="element-922">
            <div className="flex items-center justify-between mb-2" data-id="element-923">
              <div className="w-10 h-10 rounded-lg bg-blue-500/10 flex items-center justify-center text-blue-500" data-id="element-924">
                <ShieldAlert className="w-5 h-5" data-id="element-925" />
              </div>
            </div>
            <p className="text-sm text-textMuted mb-1" data-id="element-926">Venue Claims</p>
            <h4 className="text-2xl font-bold" data-id="element-927">8</h4>
          </div>
          <div className="bg-surface border border-border rounded-xl p-5" data-id="element-928">
            <div className="flex items-center justify-between mb-2" data-id="element-929">
              <div className="w-10 h-10 rounded-lg bg-red-500/10 flex items-center justify-center text-red-500" data-id="element-930">
                <ServerCrash className="w-5 h-5" data-id="element-931" />
              </div>
            </div>
            <p className="text-sm text-textMuted mb-1" data-id="element-932">Failed Jobs</p>
            <h4 className="text-2xl font-bold text-red-500" data-id="element-933">3</h4>
          </div>
          <div className="bg-surface border border-border rounded-xl p-5" data-id="element-934">
            <div className="flex items-center justify-between mb-2" data-id="element-935">
              <div className="w-10 h-10 rounded-lg bg-green-500/10 flex items-center justify-center text-green-500" data-id="element-936">
                <Activity className="w-5 h-5" data-id="element-937" />
              </div>
            </div>
            <p className="text-sm text-textMuted mb-1" data-id="element-938">System Health</p>
            <h4 className="text-2xl font-bold text-green-500" data-id="element-939">99.9%</h4>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-940">
          <div className="bg-surface border border-border rounded-xl p-6" data-id="element-941">
            <h3 className="font-semibold mb-4" data-id="element-942">Recent Audit Activity</h3>
            <div className="space-y-4" data-id="element-943">
              {[{
              action: 'Workspace Created',
              user: 'mark@thewildwoods.com',
              time: '10 mins ago'
            }, {
              action: 'API Key Generated',
              user: 'admin@booking.com',
              time: '1 hour ago'
            }, {
              action: 'Mass Import (Venues)',
              user: 'data-ops@booker.com',
              time: '2 hours ago'
            }, {
              action: 'Role Changed (Admin)',
              user: 'sysadmin',
              time: '5 hours ago'
            }].map((log, i) => <div key={i} className="flex items-center justify-between py-2 border-b border-border last:border-0" data-id="element-944">
                  <div data-id="element-945">
                    <p className="text-sm font-medium" data-id="element-946">{log.action}</p>
                    <p className="text-xs text-textMuted" data-id="element-947">{log.user}</p>
                  </div>
                  <span className="text-xs text-textMuted" data-id="element-948">{log.time}</span>
                </div>)}
            </div>
            <Link to="/admin/audit-log" className="block mt-4 text-sm text-primary hover:underline" data-id="element-949">
              View full audit log &rarr;
            </Link>
          </div>

          <div className="bg-surface border border-border rounded-xl p-6" data-id="element-950">
            <h3 className="font-semibold mb-4" data-id="element-951">Compliance Alerts</h3>
            <div className="space-y-4" data-id="element-952">
              <div className="flex items-start gap-3 p-3 bg-red-500/10 border border-red-500/20 rounded-lg" data-id="element-953">
                <AlertTriangle className="w-5 h-5 text-red-500 shrink-0" data-id="element-954" />
                <div data-id="element-955">
                  <p className="text-sm font-medium text-red-500" data-id="element-956">
                    High Bounce Rate Detected
                  </p>
                  <p className="text-xs text-textMuted mt-1" data-id="element-957">
                    Workspace 'Neon Dreams' hit 15% bounce rate on outreach.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-3 bg-amber-500/10 border border-amber-500/20 rounded-lg" data-id="element-958">
                <AlertTriangle className="w-5 h-5 text-amber-500 shrink-0" data-id="element-959" />
                <div data-id="element-960">
                  <p className="text-sm font-medium text-amber-500" data-id="element-961">
                    Spam Complaint
                  </p>
                  <p className="text-xs text-textMuted mt-1" data-id="element-962">
                    Contact 'booking@thesinclair.com' reported email as spam.
                  </p>
                </div>
              </div>
            </div>
            <Link to="/admin/compliance" className="block mt-4 text-sm text-primary hover:underline" data-id="element-963">
              Manage compliance &rarr;
            </Link>
          </div>
        </div>
      </motion.div>
    </div>;
}